import {combineReducers} from "redux";

import LaunchReducers from './Reducers/Launches';

export default combineReducers({
    launchData: LaunchReducers
});
